<template>
  <span class="app-minibars" :style="rootStyle" aria-hidden="true">
    <span
      v-for="(bar, i) in bars"
      :key="i"
      class="app-minibars__bar"
      :class="bar.cls"
      :style="bar.style"
    ></span>
  </span>
</template>

<script>
// Minibalken (Spezifikation 2.10, gen_r3.py:532–542): je Wert ein Balken (Abstand 4, Radius 2 2 0 0),
// Höhe |v| / max · 100 %, mindestens 8 %; Vormonate --d-cmp, gewählter Monat (current) --d-foc;
// Wert 0 als 2-px-Linie --d-trk. height: 32 (Handy 24). Rein dekorativ (aria-hidden).
export default {
  name: 'AppMiniBars',
  props: {
    values: { type: Array, default: () => [] },
    current: { type: Number, default: null },
    height: { type: [Number, String], default: 32 }
  },
  computed: {
    rootStyle() {
      return { height: (Number(this.height) || 32) + 'px' };
    },
    bars() {
      const nums = this.values.map(v => Math.abs(Number(v)) || 0);
      const max = nums.length ? Math.max.apply(null, nums) || 1 : 1;
      return nums.map((v, i) => {
        if (v === 0) {
          return { cls: 'app-minibars__bar--zero', style: null };
        }
        return {
          cls: i === this.current ? 'app-minibars__bar--current' : null,
          style: { height: Math.round(Math.max(v / max * 100, 8)) + '%' }
        };
      });
    }
  }
};
</script>
